'use client';

import { c as _c } from "react/compiler-runtime";
import { useClipboard } from '@common/hooks';
import { SvgBookmarkFill, SvgChevrondown, SvgCircleClock, SvgPhoneFill, SvgPin, SvgWeb } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';
import { BOOKMARK_TYPE } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { useBookmark } from '@/hooks/useBookmark';
interface HospitalCardProps {
  href?: string;
  title?: string;
  address?: string;
  tel?: string;
  emergencyTel?: string;
  link?: string;
  className?: string;
  dayTextList?: string[];
  todayText?: string;
  type?: string;
  distance?: number | null;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isUseBookmark?: boolean;
  isBookmarked?: boolean;
  isEmergency?: boolean;
  id: number;
  hasTel?: boolean;
}
export const HospitalCard = t0 => {
  const $ = _c(70);
  const {
    href: t1,
    title,
    address,
    tel,
    emergencyTel,
    link,
    className,
    onClick,
    dayTextList,
    todayText,
    type,
    distance,
    isUseBookmark: t2,
    isBookmarked: t3,
    isEmergency: t4,
    id,
    hasTel: t5
  } = t0;
  const href = t1 === undefined ? "#" : t1;
  const isUseBookmark = t2 === undefined ? false : t2;
  const isBookmarked = t3 === undefined ? false : t3;
  const isEmergency = t4 === undefined ? false : t4;
  const hasTel = t5 === undefined ? true : t5;
  const [isOpen, setIsOpen] = useState(false);
  const {
    bookmark
  } = useBookmark();
  let distanceText = "";
  if (distance) {
    distanceText = distance >= 1000 ? `${Math.floor(distance * 10 / 1000) / 10}km` : `${Math.floor(distance)}m`;
  }
  const copy = useClipboard();
  let t6;
  if ($[0] !== dayTextList) {
    t6 = dayTextList ?? [];
    $[0] = dayTextList;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let otherDayTextList = t6;
  let titleDateText = todayText;
  if (!titleDateText) {
    const firstDayText = dayTextList?.[0];
    if (firstDayText) {
      titleDateText = firstDayText;
      let t7;
      if ($[2] !== otherDayTextList) {
        t7 = otherDayTextList.slice(1);
        $[2] = otherDayTextList;
        $[3] = t7;
      } else {
        t7 = $[3];
      }
      otherDayTextList = t7;
    }
  }
  const hasOtherDayText = !(isEmergency || !otherDayTextList.length);
  let t7;
  if ($[4] !== className) {
    t7 = cn("flex w-full select-none flex-col pb-4 pt-16", className);
    $[4] = className;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== onClick) {
    t8 = e => {
      onClick?.(e);
    };
    $[6] = onClick;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== title) {
    t9 = <strong className="w-fit font-600 typo-body3">{title}</strong>;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== type) {
    t10 = <div className="mb-auto mt-1 size-fit text-nowrap rounded-xxsmall border border-Gray-300 bg-Gray-100 px-6 font-600 text-Gray-800 typo-caption1">{type}</div>;
    $[10] = type;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className="flex items-center gap-4">{t9}{t10}</div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== distanceText) {
    t12 = distanceText ? <span className="typo-caption1">{distanceText}</span> : null;
    $[15] = distanceText;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <header className="mb-8 flex items-center justify-between gap-16">{t11}{t12}</header>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== address || $[21] !== copy) {
    t14 = address ? <li className="flex gap-8"><SvgPin className="mt-4 size-14 text-Gray-500" /><address className="flex-1 break-keep not-italic text-Gray-800 typo-body4">{address}{" "}<button className="text-B-500 hover:underline" type="button" onClick={e_0 => {
          e_0.preventDefault();
          copy({
            message: "\uC8FC\uC18C\uB97C \uBCF5\uC0AC\uD588\uC5B4\uC694",
            value: address
          });
        }}>복사</button></address></li> : null;
    $[20] = address;
    $[21] = copy;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isEmergency || $[24] !== isOpen) {
    t15 = e_1 => {
      e_1.preventDefault();
      if (!isEmergency) {
        setIsOpen(!isOpen);
      }
    };
    $[23] = isEmergency;
    $[24] = isOpen;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = hasOtherDayText && isOpen;
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SvgCircleClock className="size-12 text-Gray-500" />;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  const t18 = isEmergency ? "24\uC2DC\uAC04" : titleDateText;
  let t19;
  if ($[27] !== hasOtherDayText) {
    t19 = hasOtherDayText ? <SvgChevrondown className="size-16 text-Gray-500" /> : null;
    $[27] = hasOtherDayText;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t15 || $[30] !== t16 || $[31] !== t18 || $[32] !== t19) {
    t20 = <li><button type="button" className="flex w-fit items-center gap-8 text-left text-Gray-800 typo-body4" onClick={t15} aria-expanded={t16}>{t17}{t18}{t19}</button></li>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== hasOtherDayText || $[35] !== isOpen || $[36] !== otherDayTextList) {
    t21 = hasOtherDayText && isOpen ? otherDayTextList?.map(_temp) : null;
    $[34] = hasOtherDayText;
    $[35] = isOpen;
    $[36] = otherDayTextList;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <ul>{t20}{t21}</ul>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== hasTel || $[42] !== tel) {
    t23 = tel ? <li className="flex w-fit gap-8 typo-body4"><SvgPhoneFill className="mt-4 size-14 text-Gray-500" /><p className="text-Gray-800">{tel}</p>{hasTel ? <button className="text-B-500 hover:underline" type="button" onClick={e_2 => {
        e_2.preventDefault();
        window.location.href = `tel:${tel}`;
      }}>전화</button> : null}</li> : null;
    $[41] = hasTel;
    $[42] = tel;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== emergencyTel || $[45] !== hasTel) {
    t24 = emergencyTel ? <li className="ml-22 flex w-fit gap-8 typo-body4"><p className="text-Gray-800">{emergencyTel} (응급실)</p>{hasTel ? <button className="text-B-500 hover:underline" type="button" onClick={e_3 => {
        e_3.preventDefault();
        window.location.href = `tel:${emergencyTel}`;
      }}>전화</button> : null}</li> : null;
    $[44] = emergencyTel;
    $[45] = hasTel;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== link) {
    t25 = link ? <li className="flex w-fit gap-8 typo-body4"><SvgWeb className="mt-4 size-14 text-Gray-500" /><p className="text-Gray-800">{link}</p></li> : null;
    $[47] = link;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t14 || $[50] !== t22 || $[51] !== t23 || $[52] !== t24 || $[53] !== t25) {
    t26 = <ul className="mb-12 flex flex-1 flex-col gap-4 pr-16">{t14}{t22}{t23}{t24}{t25}</ul>;
    $[49] = t14;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== bookmark || $[56] !== id || $[57] !== isBookmarked || $[58] !== isUseBookmark || $[59] !== title) {
    t27 = isUseBookmark ? <button type="button" className="mb-12 flex items-end" onClick={e_4 => {
      e_4.preventDefault();
      bookmark({
        contentId: id,
        isBookmarked,
        bookmarkType: BOOKMARK_TYPE.EMERGENCY_ROOM,
        contentName: title
      });
    }}><SvgBookmarkFill className={cn("size-16 fill-Gray-400 text-Gray-400", isBookmarked && "fill-B-500 text-B-500")} /></button> : null;
    $[55] = bookmark;
    $[56] = id;
    $[57] = isBookmarked;
    $[58] = isUseBookmark;
    $[59] = title;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t26 || $[62] !== t27) {
    t28 = <section className="flex w-full justify-between">{t26}{t27}</section>;
    $[61] = t26;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== href || $[65] !== t13 || $[66] !== t28 || $[67] !== t7 || $[68] !== t8) {
    t29 = <CustomLink className={t7} draggable={false} href={href} onClick={t8}>{t13}{t28}</CustomLink>;
    $[64] = href;
    $[65] = t13;
    $[66] = t28;
    $[67] = t7;
    $[68] = t8;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  return t29;
};
function _temp(text, index) {
  return <li key={index} className="ml-22 text-Gray-800 typo-body4">{text}</li>;
}